// Shared A4 invoice template used by single print, bulk print and bulk PDF download.

export const INVOICE_CSS = `
            @page { size: A4; margin: 8mm; }
            body {
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              margin: 0;
              padding: 8px;
              background: white;
              color: #333;
            }
            .vat-invoice-container {
              max-width: 210mm;
              min-height: 270mm;
              margin: 0 auto;
              border: 2px solid #000;
              padding: 10px;
              display: flex;
              flex-direction: column;
            }
            .header-section {
              border-bottom: 3px solid #FF7F7F;
              padding-bottom: 6px;
              margin-bottom: 8px;
            }
            .company-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .company-logo-section {
              flex: 1;
            }
            .company-name {
              font-size: 13px;
              font-weight: bold;
              color: #050505ff;
              margin-bottom: 2px;
            }
            .company-tagline {
              font-size: 9px;
              color: #333;
              font-style: italic;
            }
            .company-contact {
              text-align: right;
              font-size: 14px;
              color: #0e0d0dff;
              line-height: 1.3;
            }
            .invoice-title {
              text-align: center;
              background: linear-gradient(135deg, #FF8A80 0%, #eb730a 100%);
              color: black;
              padding: 6px;
              margin: 6px 0;
              font-size: 16px;
              font-weight: bold;
              letter-spacing: 1px;
              border-radius: 4px;
              box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            }
            .info-grid {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 8px;
              margin: 6px 0;
            }
            .info-box {
              border: 1px solid #e0e0e0;
              padding: 6px;
              border-radius: 5px;
              background: #f8f9fa;
            }
            .info-box-title {
              font-weight: bold;
              font-size: 11px;
              color: #000;
              border-bottom: 2px solid #FF8A80;
              padding-bottom: 3px;
              margin-bottom: 4px;
            }
            .info-row {
              display: flex;
              padding: 2px 0;
              font-size: 9px;
              line-height: 1.2;
            }
            .info-label {
              font-weight: 600;
              width: 90px;
              color: #555;
            }
            .info-value {
              flex: 1;
              color: #333;
            }
            .items-wrapper {
              flex: 1;
              display: flex;
              flex-direction: column;
            }
            .items-table {
              width: 100%;
              border-collapse: collapse;
              margin: 6px 0;
              font-size: 9px;
              box-shadow: 0 1px 2px rgba(0,0,0,0.1);
            }
            .items-table thead {
              background: linear-gradient(135deg, #b8b8b8ff 0%, #b8b8b8ff 100%);
              color: black;
            }
            .items-table th {
              padding: 5px 4px;
              text-align: left;
              font-weight: 600;
              border-right: 1px solid rgba(255,255,255,0.2);
            }
            .items-table th:last-child {
              border-right: none;
            }
            .items-table tbody tr {
              border-bottom: 1px solid #e0e0e0;
            }
            .items-table tbody tr:nth-child(even) {
              background-color: #f8f9fa;
            }
            .items-table tbody tr:hover {
              background-color: #e3f2fd;
            }
            .items-table td {
              padding: 4px 4px;
              vertical-align: middle;
            }
            .text-right { text-align: right; }
            .text-center { text-align: center; }
            .summary-section {
              margin-top: auto;
              display: flex;
              justify-content: flex-end;
            }
            .summary-box {
              width: 280px;
              border: 2px solid #000;
              border-radius: 5px;
              overflow: hidden;
            }
            .summary-row {
              display: flex;
              justify-content: space-between;
              padding: 4px 10px;
              border-bottom: 1px solid #e0e0e0;
              font-size: 10px;
            }
            .summary-row:last-child {
              border-bottom: none;
            }
            .summary-label {
              font-weight: 600;
              color: #555;
            }
            .summary-value {
              font-weight: 500;
              color: #333;
            }
            .vat-row {
              background-color: #FFE5E5;
            }
            .total-row {
              background: linear-gradient(135deg, #FF8A80 0%, #eb730a 100%);
              color: white;
              font-size: 12px;
              font-weight: bold;
            }
            .footer-section {
              margin-top: 10px;
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              padding-top: 8px;
              border-top: 2px solid #FF8A80;
            }
            .terms-section {
              flex: 1;
              font-size: 8px;
              color: #666;
              line-height: 1.2;
            }
            .terms-title {
              font-weight: bold;
              margin-bottom: 3px;
              color: #FF8A80;
              font-size: 9px;
            }
            .signature-box {
              width: 160px;
              text-align: center;
            }
            .signature-line {
              border-top: 2px solid #000;
              margin-top: 30px;
              padding-top: 4px;
              font-weight: 600;
              color: #000;
              font-size: 9px;
            }
            .vat-badge {
              display: inline-block;
              background: #FF8A80;
              color: white;
              padding: 3px 8px;
              border-radius: 12px;
              font-size: 9px;
              font-weight: bold;
              margin-left: 8px;
            }
            .watermark {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-45deg);
              font-size: 120px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.08);
              z-index: 1;
              pointer-events: none;
              text-transform: uppercase;
              letter-spacing: 10px;
            }
            .vat-invoice-container {
              position: relative;
            }
            @media print {
              body { margin: 0; padding: 10mm; }
              .vat-invoice-container { border: none; }
              @page { margin: 0; }
            }
`;

const blobToBase64 = (blob, type) => {
  if (!blob) return null;
  const uint8Array = new Uint8Array(blob.data || blob);
  const binary = uint8Array.reduce((acc, byte) => acc + String.fromCharCode(byte), "");
  return `data:${type};base64,${btoa(binary)}`;
};

// Builds the markup of ONE invoice. ctx = { companyProfile, showVatDetails }
export const buildInvoiceBody = (invoiceData, ctx) => {
  const { companyProfile = {}, showVatDetails = false } = ctx;
  const companyName = companyProfile?.name || "CloudNet Softwares";
  const companyPhone = companyProfile?.phone_number || "+66-948712350";
  const companyEmail = companyProfile?.email || "info@cloudnetsoftwares.com";
  const companyWebsite = companyProfile?.website || "www.cloudnetsoftwares.com";
  const companyAddress = companyProfile?.address || "123 Beach Road, Pattaya, Thailand";
  const companyTaxId = companyProfile?.tax_id || "";
  const fullAddress = [
    companyAddress,
    companyProfile?.city,
    companyProfile?.state,
    companyProfile?.zip_code,
    companyProfile?.country,
  ].filter(Boolean).join(", ");
  const logoUrl = companyProfile?.logo && companyProfile?.logo_type
    ? blobToBase64(companyProfile.logo, companyProfile.logo_type)
    : null;
  const termsAndConditions = companyProfile?.terms_and_conditions || `Terms & Conditions:
• All prices are inclusive of VAT
• Payment is due upon receipt
• Goods once sold cannot be returned`;

  return `
          <div class="vat-invoice-container">
            <div class="header-section">
              <div class="company-header">
                <div class="company-logo-section">
                  ${logoUrl ? `
                    <img src="${logoUrl}" alt="${companyName} Logo" style="max-width: 140px; max-height: 60px; margin-bottom: 6px;" onerror="this.style.display='none'" />
                  ` : ''}
                  <div class="company-name">${companyName}</div>
                  ${companyTaxId ? `<div class="company-tagline">Tax ID: ${companyTaxId}</div>` : ''}
                </div>
                <div class="company-contact">
                  <div>📞 ${companyPhone}</div>
                  <div>🌐 ${companyWebsite}</div>
                  <div>📧 ${companyEmail}</div>
                  <div style="margin-top: 8px;">📍 ${fullAddress}</div>
                </div>
              </div>
            </div>

            <div class="invoice-title">
              INVOICE

            </div>

            <div class="info-grid">
              <div class="info-box">
                <div class="info-box-title">📄 Invoice Information</div>
                <div class="info-row">
                  <span class="info-label">Invoice Number:</span>
                  <span class="info-value"><strong>${invoiceData.invoice_number}</strong></span>
                </div>
                <div class="info-row">
                  <span class="info-label">Invoice Date:</span>
                  <span class="info-value">${new Date(invoiceData.setup_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Invoice Time:</span>
                  <span class="info-value">${invoiceData.inv_time || new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">Payment Method:</span>
                  <span class="info-value"><strong>${invoiceData.payment_method || 'Cash'}</strong></span>
                </div>
              </div>

              <div class="info-box">
                <div class="info-box-title">👤 Customer Details</div>
                <div class="info-row">
                  <span class="info-label">Name:</span>
                  <span class="info-value"><strong>${invoiceData.customer_name}</strong></span>
                </div>
                <div class="info-row">
                  <span class="info-label">Phone:</span>
                  <span class="info-value">${invoiceData.customer_phone}</span>
                </div>
                ${invoiceData.customer_email ? `
                <div class="info-row">
                  <span class="info-label">Email:</span>
                  <span class="info-value">${invoiceData.customer_email}</span>
                </div>` : ''}
                ${invoiceData.customer_address ? `
                <div class="info-row">
                  <span class="info-label">Address:</span>
                  <span class="info-value">${invoiceData.customer_address}</span>
                </div>` : ''}
                ${invoiceData.customer_gst ? `
                <div class="info-row">
                  <span class="info-label">Tax ID:</span>
                  <span class="info-value">${invoiceData.customer_gst}</span>
                </div>` : ''}
              </div>
            </div>

            <div class="items-wrapper">
              <table class="items-table">
                <thead>
                  <tr>
                    <th width="5%" class="text-center">#</th>
                    <th width="${showVatDetails ? '30' : '35'}%">Item Description</th>
                    <th width="12%" class="text-right">Unit Price</th>
                    <th width="8%" class="text-center">Qty</th>
                    <th width="10%" class="text-right">Amount</th>
                    <th width="10%" class="text-right">Disc%</th>
                    ${showVatDetails ? '<th width="10%" class="text-right">VAT%</th>' : ''}
                    <th width="15%" class="text-right">Net Amount</th>
                  </tr>
                </thead>
                <tbody>
                  ${invoiceData.items && invoiceData.items.length > 0 ? invoiceData.items.map((item, index) => `
                    <tr>
                      <td class="text-center">${index + 1}</td>
                      <td><strong>${item.item_name || item.iname || 'N/A'}</strong>${item.description ? `<br><i style="font-size: 10px; color: #666;">${item.description}</i>` : ''}</td>
                      <td class="text-right">฿ ${(parseFloat(item.rate || item.offerprice || 0)).toFixed(2)}</td>
                      <td class="text-center">${item.quantity || 0}</td>
                      <td class="text-right">฿ ${(parseFloat(item.rate || item.offerprice || 0) * parseFloat(item.quantity || 1)).toFixed(2)}</td>
                      <td class="text-right">${parseFloat(item.discount_percent || 0).toFixed(0)}%</td>
                      ${showVatDetails ? `<td class="text-right">${parseFloat(item.vat || 7).toFixed(0)}%</td>` : ''}
                      <td class="text-right"><strong>฿ ${(parseFloat(item.total_amount || 0)).toFixed(2)}</strong></td>
                    </tr>
                  `).join('') : `<tr><td colspan="${showVatDetails ? '8' : '7'}" class="text-center">No items found</td></tr>`}
                </tbody>
              </table>
            </div>

            <hr style="border: none; border-top: 3px solid #000; margin: 15px 0;" />

            <div class="summary-section">
              <div class="summary-box">
                <div class="summary-row">
                  <span class="summary-label">Subtotal:</span>
                  <span class="summary-value">฿ ${parseFloat(invoiceData.subtotal || invoiceData.total || 0).toFixed(2)}</span>
                </div>
                <div class="summary-row">
                  <span class="summary-label">Discount:</span>
                  <span class="summary-value">- ฿ ${parseFloat(invoiceData.discount_value || 0).toFixed(2)}</span>
                </div>
                ${showVatDetails ? `
                <div class="summary-row">
                  <span class="summary-label">Subtotal After Discount:</span>
                  <span class="summary-value">฿ ${(parseFloat(invoiceData.subtotal || 0) - parseFloat(invoiceData.discount_value || 0)).toFixed(2)}</span>
                </div>
                <div class="summary-row vat-row">
                  <span class="summary-label">🔖 VAT (7%):</span>
                  <span class="summary-value">฿ ${parseFloat(invoiceData.tax || 0).toFixed(2)}</span>
                </div>
                <div class="summary-row">
                  <span class="summary-label">Round Off:</span>
                  <span class="summary-value">฿ ${parseFloat(invoiceData.round_off || 0).toFixed(2)}</span>
                </div>
                ` : ''}
                <div class="summary-row total-row">
                  <span class="summary-label">GRAND TOTAL:</span>
                  <span class="summary-value">฿ ${parseFloat(invoiceData.grand_total || 0).toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div class="footer-section">
              <div class="terms-section">
                <div class="terms-title">Terms & Conditions:</div>
                ${termsAndConditions.split('\n').map(line => `<div>${line}</div>`).join('')}
                <div style="margin-top: 15px; font-size: 10px; font-style: italic;">
                  This is a computer-generated invoice and does not require a physical signature.
                </div>
              </div>
              ${(companyProfile?.bank_name || companyProfile?.account_number) ? `
              <div class="bank-details-box" style="width: 250px; border: 1px solid #e0e0e0; padding: 8px; border-radius: 5px; background: #f8f9fa; margin: 0 15px;">
                <div style="font-weight: bold; font-size: 10px; color: #000; border-bottom: 2px solid #FF8A80; padding-bottom: 3px; margin-bottom: 4px;">
                  🏦 Bank Details
                </div>
                ${companyProfile?.bank_name ? `
                <div style="font-size: 8px; padding: 2px 0;">
                  <span style="font-weight: 600; color: #555;">Bank Name:</span>
                  <span style="color: #333; margin-left: 5px;">${companyProfile.bank_name}</span>
                </div>` : ''}
                ${companyProfile?.account_name ? `
                <div style="font-size: 8px; padding: 2px 0;">
                  <span style="font-weight: 600; color: #555;">Account Name:</span>
                  <span style="color: #333; margin-left: 5px;">${companyProfile.account_name}</span>
                </div>` : ''}
                ${companyProfile?.account_number ? `
                <div style="font-size: 8px; padding: 2px 0;">
                  <span style="font-weight: 600; color: #555;">Account Number:</span>
                  <span style="color: #333; margin-left: 5px;">${companyProfile.account_number}</span>
                </div>` : ''}
                ${companyProfile?.routing_number ? `
                <div style="font-size: 8px; padding: 2px 0;">
                  <span style="font-weight: 600; color: #555;">Routing Number:</span>
                  <span style="color: #333; margin-left: 5px;">${companyProfile.routing_number}</span>
                </div>` : ''}
                ${companyProfile?.swift_code ? `
                <div style="font-size: 8px; padding: 2px 0;">
                  <span style="font-weight: 600; color: #555;">SWIFT Code:</span>
                  <span style="color: #333; margin-left: 5px;">${companyProfile.swift_code}</span>
                </div>` : ''}
              </div>
              ` : ''}
              <div class="signature-box">
                <div class="signature-line">
                  Authorized Signatory
                </div>
              </div>
            </div>
          </div>
  `;
};

// Wraps one or many invoice bodies into a printable HTML document (each invoice on its own page).
export const buildInvoiceDocument = (bodies, title) => `<!DOCTYPE html>
<html>
<head>
  <title>${title}</title>
  <style>
${INVOICE_CSS}
    .invoice-page { page-break-after: always; break-after: page; }
    .invoice-page:last-child { page-break-after: auto; break-after: auto; }
  </style>
</head>
<body>
${bodies.map((b) => `<div class="invoice-page">${b}</div>`).join("")}
</body>
</html>`;
